import { useLocation, useHistory } from 'react-router-dom';
import queryString, { ParsedQuery } from 'query-string';

interface OnQueryParamPush {
  [key: string]: any;
}

type OnQueryParamPushFunction = (
  keyValuePair: OnQueryParamPush,
  replace?: boolean,
) => any;

interface OnQueryParamSet {
  [key: string]: any;
}

type OnQueryParamSetFunction = (
  keyValuePair: OnQueryParamSet,
  replace?: boolean,
) => any;

/**
 * @description Handles adding query params to the URL for you, by providing
 * a key and value.
 */
export function useQueryParams(
  options?: queryString.ParseOptions,
): [ParsedQuery<string>, OnQueryParamPushFunction, OnQueryParamSetFunction] {
  const location = useLocation();
  const history = useHistory();

  function onQueryParamPush(qps: OnQueryParamPush, replace = false) {
    // Don't overwrite current query params
    const currentQueryParams = {
      ...queryString.parse(location.search),
      ...qps,
    };
    if (replace) {
      history.replace({
        ...history.location,
        search: queryString.stringify(currentQueryParams, options),
      });
    } else {
      history.push({
        ...history.location,
        search: queryString.stringify(currentQueryParams, options),
      });
    }
  }

  const onSetQueryParams = (qps: OnQueryParamSet, replace = false) => {
    if (replace) {
      history.replace({
        search: queryString.stringify(qps, options),
      });
    } else {
      history.push({
        search: queryString.stringify(qps, options),
      });
    }
  };

  const queryParams = queryString.parse(location.search, options);

  return [queryParams, onQueryParamPush, onSetQueryParams];
}

export default useQueryParams;
